import { differenceInCalendarDays } from 'date-fns';
import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class Subscription extends Model<Schemas['subscriptions'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get expiresAtDate() {
        return nullableDate(this.expiresAt);
    }

    /**
     * When this Clinical Medicine subscription was upgraded to IMG Ready MCQ.
     *
     * It's null for any other subscription, and once a revert or renewal brings
     * this one back.
     */
    get upgradedAtDate() {
        return nullableDate(this.upgradedAt);
    }

    get daysRemaining(): number | null {
        if (this.expiresAtDate === null) return null;

        return differenceInCalendarDays(this.expiresAtDate, new Date());
    }

    get isExpired(): boolean {
        return !!this.expiresAtDate && this.expiresAtDate < new Date();
    }

    get isActive(): boolean {
        return !this.isExpired;
    }

    get lastPayment() {
        return this.payments?.[this.payments.length - 1];
    }
}
